import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import DBService from '../../service/DBService';
import { Link } from 'react-router-dom';

class MixHigh extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
        };
    }

    getLength(result){
        return (result.length > 3 ? 3 : result.length)
    }    

    componentDidMount() {
        DBService.getNewHigh()
            .then(result => {
                result = result.data;
                console.log('getNewHigh', result);
                let filteredData = [];
                if (result.length > 0) {
                    for (var i = 0; i < this.getLength(result); i++) {
                        result[i].url = '/stocks/newHigh';
                        result[i].signal = 'New High';
                        filteredData.push(result[i]);
                    }
                }

                DBService.getNew52High()
                    .then(result => {
                        result = result.data;
                        console.log('getNew52High', result);
                        if (result.length > 0) {
                            for (var i = 0; i < this.getLength(result); i++) {
                                result[i].url = '/stocks/new52High';
                                result[i].signal = '52 Week High';
                                filteredData.push(result[i]);
                            }
                        }

                        DBService.getOverBought()
                            .then(result => {
                                result = result.data;
                                console.log('getOverBought', result);
                                if (result.length > 0) {
                                    for (var i = 0; i < this.getLength(result); i++) {
                                        result[i].url = '/stocks/overBought';
                                        result[i].signal = 'Over Bought';
                                        filteredData.push(result[i]);
                                    }
                                }

                                DBService.getUnusualVolume()
                                .then(result => {
                                    result = result.data;
                                    console.log('getUnusualVolume', result);
                                    if (result.length > 0) {
                                        for (var i = 0; i < this.getLength(result); i++) {
                                            result[i].url = '/stocks/unusualVolume';
                                            result[i].signal = 'Unusual Volume';
                                            filteredData.push(result[i]);
                                        }
                                    }
    
                                    this.setState({ list: filteredData });
                                })
                                .catch((error) => {
                                    console.log(error);
                                });
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    getColor(value){
        return value >= 0 ? 'green' : 'red';
    }

    renderRow(listValue) {
        if (listValue !== undefined && listValue.symbol !== undefined) {
            let url = '/chart/' + listValue.symbol;
            let color = this.getColor(listValue.changesPercentage);
            return (
                <tr style={{color: color}} key={listValue.symbol}>
                    <td style={{ color: color }}><Link to={url}>{listValue.symbol}</Link></td>
                    <td>{parseFloat(listValue.price).toFixed(2)}</td>
                    <td>{parseFloat(listValue.changesPercentage).toFixed(2)}%</td>
                    <td ><Link style={{ color: color }} to={listValue.url}>{listValue.signal}</Link></td>
                </tr>
            )
        }
    }

    render() {
        let gainerRow;
        if (this.state.list === undefined || this.state.list.length <= 0) {
            gainerRow = <tr><td></td><td>No Data</td><td></td></tr>
        } else {
            gainerRow = this.state.list.map(this.renderRow.bind(this));
        }

        return (
            <Table bordered hover size="xs" style={{ fontSize: "10px" }}>
                <thead>
                    <tr>
                        <th>Ticker</th>
                        <th>Last</th>
                        <th>Change</th>
                        {/* <th><Link to={'/stocks/newHigh'}>New High</Link></th> */}
                        <th>Signal</th>
                    </tr>
                </thead>
                <tbody>
                    {gainerRow}
                </tbody>
            </Table>
        );
    }
}

export default MixHigh;
